var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.userData.loggedIn
    ? _c(
        "div",
        {
          staticClass: "gift-choice-page",
          class: _vm.collectionData.isBundle ? "bundle" : "",
          attrs: { id: "canvas" }
        },
        [
          _c(
            "div",
            {
              staticClass: "main-container no-scrollbar",
              attrs: { id: "mContainer" }
            },
            [
              _vm.collectionData.videoHeaders[0] ||
              _vm.collectionData.collectionImage
                ? _c(
                    "div",
                    {
                      staticClass: "header-container corporate p-relative w-100"
                    },
                    [
                      _vm.collectionData.videoHeaders[0]
                        ? _c("video", {
                            staticClass: "custom-header desktop",
                            class:
                              _vm.isOneRedeem || _vm.isSingleTab1Gift
                                ? "no-tabs"
                                : "",
                            attrs: {
                              autoplay: "autoplay",
                              playsinline: "",
                              muted: "",
                              loop: "loop",
                              alt: "gif",
                              src: _vm.collectionData.videoHeaders[0]
                            },
                            domProps: { muted: true }
                          })
                        : _vm.collectionData.collectionImage
                        ? _c("img", {
                            staticClass: "custom-header desktop",
                            class:
                              _vm.isOneRedeem || _vm.isSingleTab1Gift
                                ? "no-tabs"
                                : "",
                            attrs: {
                              src: _vm.collectionData.collectionImage.src,
                              width: "1920px"
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.collectionData.videoHeaders[1]
                        ? _c("video", {
                            staticClass: "custom-header mobile",
                            class:
                              _vm.isOneRedeem || _vm.isSingleTab1Gift
                                ? "no-tabs"
                                : "",
                            attrs: {
                              autoplay: "autoplay",
                              playsinline: "",
                              muted: "",
                              loop: "loop",
                              alt: "gif",
                              src: _vm.collectionData.videoHeaders[1]
                            },
                            domProps: { muted: true }
                          })
                        : _vm.collectionData.collectionImage
                        ? _c("img", {
                            staticClass: "custom-header mobile",
                            class:
                              _vm.isOneRedeem || _vm.isSingleTab1Gift
                                ? "no-tabs"
                                : "",
                            attrs: {
                              src: _vm.collectionData.collectionImage.alt,
                              width: "1920px"
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.collectionData.keepHeadersTitles
                        ? _c("div", { staticClass: "floating-text" }, [
                            _c("p", { staticClass: "main-title" }, [
                              _vm._v(_vm._s(_vm.headerTitle))
                            ]),
                            _vm._v(" "),
                            _vm.collectionData.keepHeaderSubtitle
                              ? _c("p", { staticClass: "main-subtitle" }, [
                                  _vm._v(_vm._s(_vm.headerSubtitle))
                                ])
                              : _vm._e()
                          ])
                        : _vm._e()
                    ]
                  )
                : _c(
                    "div",
                    { staticClass: "header-container p-relative w-100" },
                    [
                      _c("img", {
                        staticClass: "w-100 desktop",
                        attrs: {
                          src:
                            "https://cdn.shopify.com/s/files/1/1363/8433/files/goc_header_new_1.png?v=1750865983",
                          width: "1920"
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "w-100 mobile",
                        attrs: {
                          src:
                            "https://cdn.shopify.com/s/files/1/1363/8433/files/goc_header_new_mobile.png?v=1750865982",
                          width: "1920"
                        }
                      }),
                      _vm._v(" "),
                      _vm._m(0)
                    ]
                  ),
              _vm._v(" "),
              !_vm.isOneRedeem && !_vm.isSingleTab1Gift
                ? _c(
                    "div",
                    {
                      staticClass: "tabs",
                      class: [
                        _vm.uiState.isSticking ? "sticky" : "",
                        _vm.uiState.showTicker ? "hasTicker" : ""
                      ],
                      attrs: { id: "tabs" }
                    },
                    _vm._l(_vm.tabs, function(tab, i) {
                      return _c(
                        "div",
                        {
                          staticClass: "tab",
                          class: [
                            _vm.uiState.selectedTab == tab.value ||
                            (!_vm.uiState.selectedTab && i == 0)
                              ? "selected"
                              : "",
                            _vm.collectionData.isBundle &&
                            tab.value > 0 &&
                            _vm.tabs[tab.value - 1].currentQty > 0
                              ? "disabled"
                              : "",
                            !_vm.collectionData.isBundle && tab.currentQty == 0
                              ? "disabled"
                              : ""
                          ]
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "happybox-button white",
                              on: {
                                click: function($event) {
                                  return _vm.selectTab(tab.value)
                                }
                              }
                            },
                            [
                              _vm.collectionData.isBundle
                                ? _c("span", [
                                    _vm._v("Step " + _vm._s(i + 1) + ": ")
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              tab.maxQty == 1
                                ? _c("span", [
                                    _vm._v(
                                      "Pick " +
                                        _vm._s(tab.currentQty) +
                                        _vm._s(
                                          tab.leftOver > 0
                                            ? "+ Gift(s)"
                                            : " Gift"
                                        )
                                    )
                                  ])
                                : tab.maxQty > 1
                                ? _c("span", [
                                    _vm._v(
                                      "Pick up to " +
                                        _vm._s(tab.currentQty) +
                                        " Gifts"
                                    )
                                  ])
                                : _vm._e()
                            ]
                          )
                        ]
                      )
                    }),
                    0
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.collectionData.tickerText &&
              _vm.collectionData.tickerText != ""
                ? _c(
                    "div",
                    {
                      staticClass: "ticker",
                      style: _vm.collectionData.tickerColor
                        ? "background-color:" + _vm.collectionData.tickerColor
                        : ""
                    },
                    [_c("p", [_vm._v(_vm._s(_vm.collectionData.tickerText))])]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "products-listing" }, [
                _vm.maxProductsToAdd == 0
                  ? _c("p", { staticClass: "capacity-overlay" }, [
                      _vm._v("100% full! Proceed to the next step "),
                      _c("br", { staticClass: "mobile" }),
                      _vm._v(" or remove items to keep shopping.")
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.bundleInstructions && _vm.maxProductsToAdd != 0
                  ? _c("p", {
                      staticClass: "bundle-instructions",
                      domProps: { innerHTML: _vm._s(_vm.bundleInstructions) }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.stepWarningMessage
                  ? _c("p", { staticClass: "step-warning" }, [
                      _vm._v(_vm._s(_vm.stepWarningMessage))
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.isHBHoliday && _vm.isOneRedeem
                  ? _c("p", { staticClass: "purple-copy" }, [
                      _vm._v("Redeem your holiday gift below!")
                    ])
                  : _vm._e(),
                _vm._v(" "),
                !_vm.isHBHoliday && !_vm.collectionData.isBundle
                  ? _c("p", {
                      staticClass: "tier-subcopy",
                      domProps: { innerHTML: _vm._s(_vm.tabCopy) }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "products-inner-container-wrapper" }, [
                  _vm.collectionData.product_videos.length > 0 &&
                  _vm.collectionData.product_videos[_vm.currentTabIndex]
                    ? _c("div", { staticClass: "product-video-container" }, [
                        _c("video", {
                          attrs: {
                            id: "product-video",
                            autoplay: "",
                            loop: "",
                            muted: "",
                            alt: "product video",
                            src:
                              _vm.collectionData.product_videos[
                                _vm.currentTabIndex
                              ],
                            controls: "",
                            controlsList:
                              "nodownload noremoteplayback noplaybackrate",
                            disablepictureinpicture: ""
                          },
                          domProps: { muted: true }
                        })
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "products-inner-container",
                      class: [
                        _vm.maxProductsToAdd == 0 ? "disabled" : "",
                        _vm.collectionData.product_videos.length > 0 &&
                        _vm.collectionData.product_videos[_vm.currentTabIndex]
                          ? "has-videos"
                          : ""
                      ]
                    },
                    _vm._l(_vm.filteredProducts, function(product) {
                      return _c(
                        "div",
                        {
                          key: product.id,
                          staticClass: "product-container",
                          class: [
                            _vm.cartData.cartProducts.find(function(x) {
                              return x.id == product.id
                            })
                              ? "selected"
                              : "",
                            _vm.isOneRedeem ? "big" : ""
                          ]
                        },
                        [
                          _c("img", {
                            staticClass: "circle remove",
                            attrs: {
                              src:
                                "https://cdn.shopify.com/s/files/1/1363/8433/files/x_blue.svg?v=1784232486",
                              alt: "x"
                            },
                            on: {
                              click: function($event) {
                                return _vm.removeProduct(product)
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "product-image-container",
                              on: {
                                click: function($event) {
                                  return _vm.selectProduct(product)
                                }
                              }
                            },
                            [
                              _vm.mainBadge(product) != null
                                ? _c("span", { staticClass: "main-badge" }, [
                                    _vm._v(_vm._s(_vm.mainBadge(product)))
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _c("img", {
                                staticClass: "info",
                                attrs: {
                                  src:
                                    "https://cdn.shopify.com/s/files/1/1363/8433/files/info.svg?v=1734017876"
                                }
                              }),
                              _vm._v(" "),
                              _c("div", { staticClass: "loading" }, [
                                _c("img", {
                                  staticClass: "lazyload main-image",
                                  attrs: {
                                    width: "150",
                                    height: "150",
                                    src: _vm._f("getProductImage")(product)
                                  }
                                })
                              ]),
                              _vm._v(" "),
                              product.images.length > 1 &&
                              !_vm.isNoHover(product)
                                ? _c("img", {
                                    staticClass: "hover-image",
                                    attrs: { src: product.images[1].src }
                                  })
                                : _vm._e()
                            ]
                          ),
                          _vm._v(" "),
                          _c("p", { staticClass: "product-title" }, [
                            _vm._v(_vm._s(product.title))
                          ]),
                          _vm._v(" "),
                          _vm.isOneRedeem
                            ? _c(
                                "button",
                                {
                                  staticClass: "happybox-button green border",
                                  on: {
                                    click: function($event) {
                                      return _vm.selectProduct(product)
                                    }
                                  }
                                },
                                [_vm._v("Redeem")]
                              )
                            : _vm._e()
                        ]
                      )
                    }),
                    0
                  )
                ])
              ])
            ]
          ),
          _vm._v(" "),
          _c("SideCart", {
            attrs: {
              capacity: _vm.percentageFilledCapacity,
              selectedProducts: _vm.cartData.cartProducts,
              maxProductsToAdd: _vm.maxProductsToAdd,
              isLoading: _vm.uiState.isLoading,
              isBundle: _vm.collectionData.isBundle,
              tabs: _vm.tabs,
              redeem_without_full_capacity:
                _vm.collectionData.redeem_without_full_capacity,
              minimumProductsToAdd: _vm.minimumProductsToAdd,
              canCheckout: _vm.canProceedToCheckout
            },
            on: {
              removeproduct: function($event) {
                return _vm.removeProduct($event)
              },
              checkout: _vm.goCheckout,
              openmodal: function($event) {
                return _vm.openModal($event)
              }
            }
          }),
          _vm._v(" "),
          _vm.uiState.selectedProduct
            ? _c("ProductModal", {
                attrs: {
                  collectionValue: _vm.collectionValue,
                  availableCapacity: _vm.availableCapacity,
                  product: _vm.uiState.selectedProduct,
                  cartProducts: _vm.cartData.cartProducts,
                  isLoading: _vm.uiState.isLoading,
                  isBundle: _vm.collectionData.isBundle,
                  tabs: _vm.tabs,
                  isOneRedeem: _vm.isOneRedeem,
                  collectionHandle: _vm.collectionData.collectionHandle
                },
                on: {
                  closemodal: _vm.closeModal,
                  changevariant: _vm.changeVariant,
                  selectproduct: function($event) {
                    return _vm.addProduct($event)
                  },
                  cleanadd: function($event) {
                    return _vm.cleanAdd($event)
                  },
                  checkout: _vm.goCheckout,
                  nextstep: function($event) {
                    return _vm.nextStep()
                  }
                }
              })
            : _vm._e()
        ],
        1
      )
    : _vm.sso && !_vm.loginData.loading
    ? _c("div", { staticClass: "login-page", style: _vm.loginPageStyle }, [
        _c("img", {
          staticClass: "logo",
          attrs: {
            src:
              _vm.loginData.loginLogo ||
              "https://cdn.shopify.com/s/files/1/1363/8433/files/LOGO_sparkle-01.png?v=1726671236",
            alt: "Happy Box Logo"
          }
        }),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "login-container" },
          [
            _c("div", { staticClass: "login-header" }, [
              _c("h2", {
                style: _vm.loginData.loginTitleColor
                  ? "color:" + _vm.loginData.loginTitleColor
                  : "",
                domProps: {
                  innerHTML: _vm._s(
                    _vm.loginData.loginTitle || "Login to Happy Box"
                  )
                }
              }),
              _vm._v(" "),
              _vm.loginData.loginSubtitle
                ? _c(
                    "p",
                    {
                      staticClass: "body-base",
                      style: _vm.loginData.loginSubtitleColor
                        ? "color:" + _vm.loginData.loginSubtitleColor
                        : ""
                    },
                    [_vm._v(_vm._s(_vm.loginData.loginSubtitle))]
                  )
                : _vm._e()
            ]),
            _vm._v(" "),
            !_vm.loadingSSO
              ? [
                  _vm.userData.isLoggedIn && _vm.userData.loggedUser
                    ? _c("div", { staticClass: "logged-container" }, [
                        _vm._v(
                          "\n              You are logged in as " +
                            _vm._s(_vm.userData.loggedUser.email) +
                            " "
                        ),
                        _c("br"),
                        _vm._v(
                          " which does not have access to this collection.\n              "
                        ),
                        _c("div", { staticClass: "signup-prompt" }, [
                          _c("p", [
                            _c(
                              "a",
                              {
                                attrs: { href: "#" },
                                on: { click: _vm.logout }
                              },
                              [_vm._v("Try Again")]
                            )
                          ])
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "alternative-login" }, [
                    _c(
                      "button",
                      {
                        staticClass: "google-sign-in-button",
                        attrs: { type: "button" },
                        on: {
                          click: function($event) {
                            return _vm.ssologin("google")
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n                  Sign in with Google\n              "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _vm.loginData.hideMSButton == false
                      ? _c(
                          "button",
                          {
                            staticClass: "google-sign-in-button microsoft",
                            attrs: { type: "button" },
                            on: {
                              click: function($event) {
                                return _vm.ssologin("microsoft")
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n                  Sign in with Microsoft\n              "
                            )
                          ]
                        )
                      : _vm._e()
                  ])
                ]
              : _c("div", { staticClass: "login-spinner" }, [
                  _c("div", { staticClass: "global-spinner" })
                ])
          ],
          2
        ),
        _vm._v(" "),
        _vm.loginData.loginLogo
          ? _c(
              "p",
              {
                staticClass:
                  "flex flex-align-center flex-justify-center gap-05vw font-bold body-base m-t-1rem",
                style: _vm.loginData.loginPoweredByColor
                  ? "color:" + _vm.loginData.loginPoweredByColor
                  : ""
              },
              [
                _vm._v("Powered by "),
                _c("img", {
                  staticClass: "h-auto",
                  attrs: {
                    width: "40",
                    src:
                      "https://cdn.shopify.com/s/files/1/1363/8433/files/LOGO_sparkle-01.png?v=1726671236",
                    alt: "Happy Box Logo"
                  }
                })
              ]
            )
          : _vm._e()
      ])
    : _c(
        "div",
        {
          staticClass: "spinner-container",
          class: _vm.uiState.reclaimed ? "top" : ""
        },
        [
          _vm.uiState.invalidToken
            ? _c("p", [_vm._v("Invalid Access")])
            : _vm.uiState.reclaimed
            ? _c("div", { staticClass: "reclaimed-container" }, [
                _vm._m(1),
                _vm._v(" "),
                _c("p", { staticClass: "subtitle" }, [
                  _vm._v("You'll receive updates and tracking info via email!")
                ])
              ])
            : _c("div", { staticClass: "loading-container" }, [
                _vm._m(2),
                _vm._v(" "),
                _c("div", { staticClass: "spinner" })
              ])
        ]
      )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "floating-text" }, [
      _c("p", { staticClass: "main-title" }, [_vm._v("Pick Your Gift!")]),
      _vm._v(" "),
      _c("p", { staticClass: "main-subtitle" }, [
        _vm._v(" You can pick one or many gifts to hit the "),
        _c("br", { staticClass: "mobile" }),
        _vm._v(" value your sender has selected. ")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "title" }, [
      _c("img", {
        attrs: {
          src:
            "https://cdn.shopify.com/s/files/1/1363/8433/files/sparkle_4a4131fa-65f2-4bcc-afa8-afb2663b6968.svg?v=1646844031"
        }
      }),
      _vm._v(" "),
      _c("span", [_vm._v("Great Choice")]),
      _vm._v(" "),
      _c("img", {
        attrs: {
          src:
            "https://cdn.shopify.com/s/files/1/1363/8433/files/sparkle_4a4131fa-65f2-4bcc-afa8-afb2663b6968.svg?v=1646844031"
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v(
        "\n      If you are having trouble loading this page, please turn off your VPN or company wifi. "
      ),
      _c("br", { staticClass: "desktop" }),
      _vm._v(
        " Due to IT security restrictions, you may need to open the link on a personal device or forward the email to a personal email address to redeem your gift."
      ),
      _c("br", { staticClass: "desktop" }),
      _vm._v("\n      If you are still having issues, please reach out to "),
      _c("a", { attrs: { href: "mailto:orders@happyboxstore.com" } }, [
        _vm._v("orders@happyboxstore.com")
      ]),
      _vm._v(" for immediate assistance.\n    ")
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }